// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { primaryImageStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { IconWrapper } from "@insite/mobius/Icon";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

primaryImageStyles.fullPrimaryImageModal = {
    mergeCss: true,
    cssOverrides: {
        modalContainer: css`
            width: auto;
        `,
        modalBody: css`
            width: auto;
            max-width: initial;
            max-height: initial !important;
        `,
        headlineTypography: css`
            ${xScreen("gte", "md")} {
                display: none;
            }
        `,
        modalTitle: css`
            border-bottom: none;
            padding: 0;
            &:after {
                ${xScreen("gte", "md")} {
                    display: none;
                }
            }
            ${xScreen("lte", 767)} {
                position: relative;
                padding: 17px 17px 8px;
            }
        `,
        modalContent: css`
            text-align: center;
            padding: 22px;
        `,
    },
    closeButtonProps: {
        mergeCss: true,
        css: css`
            padding: 0;
            min-height: 21px;
            border: none;
            ${xScreen("gte", "md")} {
                position: absolute;
                top: 13px;
                right: 13px;
                z-index: 2;
            }
            &&:hover,
            &&:focus {
                background: transparent;
            }
            &&:hover > ${IconWrapper}, &&:focus > ${IconWrapper} {
                color: ${color("common.ui8")};
            }
        `,
    },
};
primaryImageStyles.fullPrimaryImage = {
    image: {
        css: css`
            cursor: auto;
            img {
                width: auto;
                max-height: 70vh;
            }
        `,
    },
    img: {
        css: css`
            cursor: auto;
            width: auto;
            max-height: 70vh;
        `,
    },
};

primaryImageStyles.primaryImage = {
    ...primaryImageStyles.primaryImage,
    centeringWrapper: {
        css: css`
            border-radius: 4px;
            overflow: hidden;
            margin: 0;
            width: 508px;
            height: 508px;
            img {
                width: 100%;
                height: auto;
            }
            ${xScreen("lte", "lg")} {
                width: 430px;
                height: 430px;
            }
            ${xScreen("lte", 1200)} {
                width: 300px;
                height: 300px;
            }
            ${xScreen("lte", "md")} {
                width: 358px;
                height: 358px;
            }
        `,
    },
    img: {
        css: css`
            width: 100%;
            height: auto;
            max-height: 100%;
            max-width: 100%;
            object-fit: contain;
        `,
    },
};
